import { useIntl } from 'react-intl';

const useMultiLanguageExportLog = () => {
  const intl = useIntl();
  const EXPORT_LOG_LIST_TITLE = intl.formatMessage({
    id: 'authentication.exportLogList.title',
  });
  const EXPORT_LOG_LIST_TABLE_TIME = intl.formatMessage({
    id: 'authentication.exportLogList.table.title.time',
  });
  const EXPORT_LOG_LIST_TABLE_EMAIL = intl.formatMessage({
    id: 'authentication.exportLogList.table.title.email',
  });
  const EXPORT_LOG_LIST_TABLE_TYPE = intl.formatMessage({
    id: 'authentication.exportLogList.table.title.type',
  });
  return {
    EXPORT_LOG_LIST_TITLE,
    EXPORT_LOG_LIST_TABLE_TIME,
    EXPORT_LOG_LIST_TABLE_EMAIL,
    EXPORT_LOG_LIST_TABLE_TYPE,
  };
};
export default useMultiLanguageExportLog;
